import { render } from "./Regulamento.vue?vue&type=template&id=752eb683"
import script from "./Regulamento.vue?vue&type=script&lang=js"
export * from "./Regulamento.vue?vue&type=script&lang=js"
script.render = render

export default script